
  export default () => ({
    // 支付宝原始账单-下载账单
    formConfig: {
      formValue: {
        isDate: 'true',
        accountCode: ''
      },
      formData: [
        {
          style: 'dropSelect',
          width: '24',
          isActive: true,
          isdisabled: false,
          itemdata: {
            // version: '1.3',
            colid: 1700818734,
            colname: 'ALIPAY_ACCOUNT_ID', // 当前字段的名称
            display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能
            fkdisplay: 'drp', // 外键关联类型，mrp表示下拉多选
            inputname: 'ALIPAY_ACCOUNT_ID', // 这个是做中文类型的模糊查询字段，例如ENAME
            isfk: true, // 是否有fk键
            isnotnull: true, // 是否必填
            isBackRowItem: true,
            serviceId: 'r3-ac',
            name: t('支付宝账户名称'), // input前面显示的lable值
            readonly: false, // 是否可编辑，对应input   readonly属性
            columnsKey: ['ALIPAY_ACCOUNT_NAME'],
            valuedata: '' // 这个是选择的值
          },
          oneObj: (e) => {
            console.log(e);
            const { rowItem } = e
            let accountCode = rowItem
            ? typeof rowItem.ID == 'object' ? rowItem.ID.val : rowItem.value
            : ''
            window.custSelf.downLoadFormConfig.formValue.accountCode = accountCode
          }
        },
        {
          style: 'radio',
          label: t('下载方式'),
          value: 'isDate',
          width: '24',
          options: [
            // radio选项
            {
              label: t('按日下载'),
              value: 'true'
            },
            {
              label: t('按月下载'),
              value: 'false'
            },
          ],
          radioChange: () => {
            if (window.custSelf.downLoadFormConfig.formValue.isDate === 'true') {
              window.custSelf.downLoadFormConfig.formData[2].type = 'date';
              window.custSelf.downLoadFormConfig.formData[2].format = 'yyyy-MM-dd';
            } else {
              window.custSelf.downLoadFormConfig.formData[2].type = 'month';
              window.custSelf.downLoadFormConfig.formData[2].format = 'yyyy-MM';
            }
            window.custSelf.downLoadFormConfig.formValue.query_date = '';
          }
        },
        {
          style: 'date',
          type: 'date', // 日期组件类型,默认为data  (daterange)为双日期区间选择
          value: 'query_date',
          label: t('账单时间'),
          width: '24',
          format: 'yyyy-MM-dd', // 格式参照burgeonui
          placeholder: '',
          options: {
            disabledDate (date) {
              let isDate = window.custSelf.downLoadFormConfig.formValue.isDate === 'true'
              return isDate
              ? date && date.valueOf() > Date.now() - 86400000
              : date && date.valueOf() > Date.now() - 8.64e7 * (new Date().getDate());
            }
          },
        },
      ],
      // 表单非空提示
      ruleValidate: {
        query_date: [{ required: true, message: ' ' }]
      }
    },
    determine: async (self) => {
      const formValue = self.downLoadFormConfig.formValue;
      if (!self.downLoadFormConfig.formData[0].itemdata.pid) {
        self.$Message.warning(t('请选择需要下载的支付宝账户名称'));
        return;
      }
      if (!formValue.query_date) {
        self.$Message.warning(t('请选择需要下载的账单时间'));
        return;
      }
      let startTime = formValue.query_date;
      startTime = $utils.getFormatDate(startTime, 'yyyy-MM-dd');
      const param = {
        table: 'AC_F_ALIPAY_BILL_RAW_DATA',
        accountId: formValue.accountCode, // 账户名称 必传
        start_time: startTime,
        isDate: formValue.isDate == 'true',
      };
      const { data: { data }} = await self.service.financeCenter.alipayBillDownload(param)
      if (data.code === 0) {
        self.$Message.success(data.message);
        self.$emit('confirmImport');
        self.$emit('closeActionDialog');
      } else {
        $fcError(data.message);
      }
    }
  });
